export const ranges_index = ['ranges.index']
export const ranges_create = ['ranges.create']
export const ranges_edit = ['ranges.edit']

export default [].concat(
    ranges_index,
    ranges_create,
    ranges_edit
)
